import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../../enum/TableView";
import { GenericTableColumns } from "../../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../../models/RouteComponent";
import { useNavigate } from "react-router-dom";
import { siteEmployeeRemove, siteEmployeeUpdate } from "../../../service/siteService";
import EmployeePPEAdd from "./Employee-PPE-Add";
import { PPEEmployeeAdd, PPEEmployeeRemove } from "../../../service/ppeService";
import EmployeePPEUpdate from "./Employee-PPE-Update";

export default function EmployeePPETable(props: RouteComponentProps) {

  const site_id = props.session.site_id;

  const navigate = useNavigate();

  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [showModal, setShowModal] = useState<'add' | 'edit' | null>(null);
  const [reload, setReload] = useState(false);

  const toast = useRef(null as any);

  let url = 'ppe-employee';

  const baseFilter = {}

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedRecord(null);
    setShowModal('add');
  }

  const itemSelected = (row: any) => {
    const value = row.value;
    console.log("value == ", value);
    setSelectedRecord(value);
    viewSelected(row);
  }
  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedRecord(row.value);
  }

  const deleteEmployeePPE = async () => {
    props.setGlobalLoader(true);
    const client = await PPEEmployeeRemove(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Employee PPE Deleted Successfully', life: 3000 });
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => deleteEmployeePPE()
    });
  }


  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await siteEmployeeUpdate({ "active": status }, selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: status ? 'Employee Activated Successfully' : 'Employee Deactivated Successfully', life: 3000 });
  }
  const disableConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to deactivate employee?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(false)
    });
  }
  const activateConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to activate employee?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(true)
    });
  }

   const viewSelected = (row: any) => {
    setShowModal('edit');
  }

  const reIssue = (row: any) => {
    console.log("selectedRecord == ", selectedRecord)
    const data = {
      employee: props.employee.id || '',
      ppe: selectedRecord.ppe_id,
      size: selectedRecord.size || ''
    };
    props.setGlobalLoader(true);
    PPEEmployeeAdd(data).then((r: any) => {
      props.setGlobalLoader(false);
      toast.current.show({ severity: 'success', summary: 'PPE Added Successfully', life: 3000 });
      setReload(!reload);
    });
  }

  const contextItems = () => {
    let objArray = [
      { label: "View / Edit", icon: "pi pi-fw pi-pencil", command: viewSelected },
    ];
    if (!selectedRecord?.issued) {
      objArray.push({ label: 'Re Issue', icon: 'pi pi-fw pi-check-circle', command: reIssue })
    }
    objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "photo",
      header: "Image",
      type: GenericTableColumTypes.Image,
      visible: true,
      sort: false,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: ""
          }
        ]
      }
    },
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'size',
      header: 'Size',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'issued',
      header: 'Issued',
      type: GenericTableColumTypes.Boolean,
      visible: !!site_id,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'issue_at',
      header: 'Issued Date',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Date,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
  ];


  return (
    <React.Fragment>

      <GenericTableView reload={reload} baseFilters={baseFilter} queryParams={{ employeeId: props.employee.id || '' }}
        url={url} columns={columns} contextItems={contextItems} addButton={addButton}
        itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog header={"Add PPE"} visible={showModal === 'add'} style={{ width: '50vw' }} onHide={() => setShowModal(null)}>
        <EmployeePPEAdd setGlobalLoading={props.setGlobalLoader} record={selectedRecord} setReload={setReload} reload={reload} setVisible={setShowModal} toast={toast} session={props.session} employee={props.employee.id || ''} />
      </Dialog>

      <Dialog header={"Update PPE"} visible={showModal === 'edit'} style={{ width: '50vw' }} onHide={() => setShowModal(null)}>
        <EmployeePPEUpdate setGlobalLoading={props.setGlobalLoader} record={selectedRecord} setReload={setReload} reload={reload} setVisible={setShowModal} toast={toast} session={props.session} employee={props.employee.id || ''} />
      </Dialog>

      {/*There is already one on the parent page, this makes two dialogs popup when want to open one*/}
      {/*<ConfirmDialog />*/}

      <Toast ref={toast} />


    </React.Fragment>
  );
}